import { render, staticRenderFns } from "./EditContactModal.vue?vue&type=template&id=896360f8&"
import script from "./EditContactModal.vue?vue&type=script&lang=js&"
export * from "./EditContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896360f8')) {
      api.createRecord('896360f8', component.options)
    } else {
      api.reload('896360f8', component.options)
    }
    module.hot.accept("./EditContactModal.vue?vue&type=template&id=896360f8&", function () {
      api.rerender('896360f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/EditContactModal.vue"
export default component.exports